/* eslint-disable react/no-unused-prop-types */
import { useEffect, useState } from 'react';
import { string } from 'prop-types';
import _ from 'lodash';
import { t, Trans } from '@lingui/macro';

import MessageOverlay from '../../charts/message-overlay/MessageOverlay';
import Panel from '../../page-framework/panel/PanelDecorator';
import { panelPropTypes, panelPropDefaults } from '../../page-framework/panel/PanelPropTypes';
import usePanelDataService from '../../../services/PanelDataService';
import StatusChart from '../../charts/status-chart/StatusChart';

const baseDataSource = {
    url: '/query/chart',
    params: {
        metrics: ['status'],
    },
};

function StatusChartPanel({ entityType, entity }) {
    const [dataSource, setDataSource] = useState(undefined);
    const [statusTrend, setStatusTrend] = useState(undefined);
    const [widths, setWidths] = useState({});
    const data = usePanelDataService(dataSource);

    useEffect(() => {
        setDataSource(
            _.merge(
                {
                    params: {
                        type: entityType,
                    },
                },
                baseDataSource
            )
        );
    }, [entityType]);

    useEffect(() => {
        setStatusTrend(data?.data?.[0]?.trends?.status);
    }, [data]);

    return _.isNil(statusTrend) ? (
        <MessageOverlay message={<Trans>No data available</Trans>}> </MessageOverlay>
    ) : (
        <StatusChart
            statusTrend={statusTrend}
            chartData={widths}
            initialHeight={40}
            onSetWidths={setWidths}
            entity={entity}
        />
    );
}

StatusChartPanel.propTypes = {
    ...panelPropTypes,
    entityType: string.isRequired,
};

StatusChartPanel.defaultProps = {
    ...panelPropDefaults,
    title: t`Status`,
    minContentHeight: 40,
    contentHeight: 40,
    entity: {},
};

export default Panel()(StatusChartPanel);
